import { render, staticRenderFns } from "./PropertyViewBids.vue?vue&type=template&id=45dc406b&scoped=true"
import script from "./PropertyViewBids.vue?vue&type=script&lang=js"
export * from "./PropertyViewBids.vue?vue&type=script&lang=js"
import style0 from "./PropertyViewBids.vue?vue&type=style&index=0&id=45dc406b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dc406b",
  null
  
)

export default component.exports